import { selectDriverState,selectStopEvent } from "../../api/config/modules/DriverStatus";

const state = {
    selectDriverState: {},
    selectStopEvent: {}
};

const mutations = {
  SET_SELECTDRIVERSTATE: (state, selectDriverState) => {
    state.selectDriverState = selectDriverState;
  },
  SET_DRIVERSTOPEVENT: (state, selectStopEvent) => {
    state.selectStopEvent = selectStopEvent;
  }
};

const actions = {
  GET_SELECTDRIVERSTATE: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        selectDriverState(data)
        .then((res) => {
          commit("SET_SELECTDRIVERSTATE", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  GET_DRIVERSTOPEVENT: ({ commit }, data) => {
    return new Promise((resolve, reject) => {
        selectStopEvent(data)
        .then((res) => {
          commit("SET_DRIVERSTOPEVENT", res);
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
